export default __webpack_public_path__ + "static/dashboard_err-eb99a422377f37a749bc57ae94c7bcf4.png";